// import { async } from 'regenerator-runtime';
import { fetchAuthenticatedUser } from '.';
import { getApiErrorMessage } from '../utils/apiError';
import * as onboardingApi from '../api/onboardingApi';
import { gtag } from '../components/Analytics/gtag';
import { ratingTypes } from '../utils/constants';
import { setPlayerId } from './profile-actions';
import links from '../../config/links';
import { NuoSteps } from '../pages/NuoV2/YourRating/constants';
import { showErrorPopup } from './notification-actions';

export const ONBOARDING_REDIRECT_ON_COMPLETE = 'ONBOARDING:REDIRECT_ON_COMPLETE';
export const ONBOARDING_SET_PLAYERID = 'ONBOARDING:SET_PLAYERID';
export const ONBOARDING_POST_UTR_RANGE_SURVEY = 'ONBOARDING:POST_UTR_RANGE_SURVEY';
export const ONBOARDING_POST_UTR_RANGE_SURVEY_SUCCESS = 'ONBOARDING:POST_UTR_RANGE_SURVEY_SUCCESS';
export const CHANGE_FEED_PREFERRENCE_MODAL_DISPLAY = 'CHANGE_FEED_PREFERRENCE_MODAL_DISPLAY';
export const ONBOARDING_POST_UTR_RANGE_SURVEY_FAILURE = 'ONBOARDING:POST_UTR_RANGE_SURVEY_FAILURE';
export const ONBOARDING_SET_DISABLE_RANGE_SURVEY_SKIP = 'ONBOARDING:SET_DISABLE_RANGE_SURVEY_SKIP';
export const ONBOARDING_SKIP_UTR_RANGE_SURVEY = 'ONBOARDING:SKIP_UTR_RANGE_SURVEY';
export const ONBOARDING_SKIP_UTR_RANGE_SURVEY_SUCCESS = 'ONBOARDING:SKIP_UTR_RANGE_SURVEY_SUCCESS';
export const ONBOARDING_SKIP_UTR_RANGE_SURVEY_FAILURE = 'ONBOARDING:SKIP_UTR_RANGE_SURVEY_FAILURE';
export const ONBOARDING_POST_AUSTRALIA_ONBOARDING_STATUS_SUCCESS = 'ONBOARDING:POST_AUSTRALIA_ONBOARDING_STATUS_SUCCESS';
export const ONBOARDING_POST_AUSTRALIA_TENNIS_ID_SUCCESS = 'ONBOARDING:ONBOARDING_POST_AUSTRALIA_TENNIS_ID_SUCCESS';
export const ONBOARDING_SET_SKIP_ONBOARDING_INTRO_POPUP = 'ONBOARDING:SET_SKIP_ONBOARDING_INTRO_POPUP';
export const ONBOARDING_SHOW_RANGE_POPUP = 'ONBOARDING:SHOW_RANGE_POPUP';
export const ONBOARDING_SHOW_PBR_RANGE_POPUP = 'ONBOARDING:SHOW_PBR_RANGE_POPUP';
export const ONBOARDING_GET_RATED_POPUP_DISMISSED = 'ONBOARDING:GET_RATED_POPUP_DISMISSED';
export const ONBOARDING_SET_SHOW_RATING = 'ONBOARDING_SET_SHOW_RATING';
export const ONBOARDING_SET_SHOW_POWER = 'ONBOARDING_SET_SHOW_POWER';
export const ONBOARDING_GET_NUO_STATUS = 'ONBOARDING_SET_NUO_STATUS';
export const ONBOARDING_GET_NUO_STATUS_SUCCESS = 'ONBOARDING_SET_NUO_STATUS_SUCCESS';
export const ONBOARDING_POST_NUO_DATA = 'ONBOARDING_POST_NUO_DATA';
export const ONBOARDING_POST_NUO_DATA_FAILURE = 'ONBOARDING_POST_NUO_DATA_FAILURE';
export const ONBOARDING_POST_PICKLEBALL_RANGE_SURVEY = 'ONBOARDING_POST_PICKLEBALL_RANGE_SURVEY';
export const ONBOARDING_POST_PICKLEBALL_RANGE_SURVEY_SUCCESS = 'ONBOARDING_POST_PICKLEBALL_RANGE_SURVEY_SUCCESS';
export const ONBOARDING_POST_PICKLEBALL_RANGE_SURVEY_FAILURE = 'ONBOARDING_POST_PICKLEBALL_RANGE_SURVEY_FAILURE';

const TennisValidationStatusCode = 210005;
const TENNIS_VALIDATION_POPUP_DESCRIPTION = `This is an 11-digit number that starts with 66 and can be found on your profile page on MatchCentre or the Tournament site. For more information, <a target="_blank" rel="noopener noreferrer" href=${links.supportTennisID}>Click Here</a>`;

export const setClaimedPlayerId = (playerId) => (dispatch) => {
    dispatch({
        type: ONBOARDING_SET_PLAYERID,
        playerId,
    });
};

export const redirctOnComplete = (url) => (dispatch) => {
    dispatch({
        type: ONBOARDING_REDIRECT_ON_COMPLETE,
        url,
    });
};

export const setDisableRangeSurveySkip = (bool) => (dispatch) => {
    dispatch({
        type: ONBOARDING_SET_DISABLE_RANGE_SURVEY_SKIP,
        payload: bool,
    });
};

export const setSkipOnboardingIntroPopup = (bool) => (dispatch) => {
    dispatch({
        type: ONBOARDING_SET_SKIP_ONBOARDING_INTRO_POPUP,
        payload: bool,
    });
};

export const getOnboardingStatus = () => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await onboardingApi.getOnboardingStatus(mainApi);
        if (res.data.error) {
            dispatch(showErrorPopup({
                message: 'Error fetching onboarding status!',
                error: res.data.error,
            }));
        } else {
            return res.data;
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error fetching onboarding status',
            error,
        }));
    }
};

export const getStudentInfo = (playerId) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await onboardingApi.getStudentInfo(mainApi, playerId);

        if (res.data) {
            return res.data;
        }
    } catch (error) {
        console.log(error);
    }
};

export const optCollegeRecruitment = (optIn) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await onboardingApi.optCollegeRecruitment(mainApi, {
            optIn,
        });

        if (res.data.error) {
            dispatch(showErrorPopup({
                message: 'Error fetching onboarding status!',
                error: res.data.error,
            }));
        } else {
            return true;
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error fetching onboarding status',
            error,
        }));
    }
};

export const updatePBRRange = (values) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await onboardingApi.updatePBRRangeV2(mainApi, values);
        if (res.data.error) {
            dispatch(showErrorPopup({
                message: `Error updating ${ratingTypes.colorBall} range!`,
                error: res.data.error,
            }));
        } else {
            return true;
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: `Error updating ${ratingTypes.colorBall} range`,
            error: getApiErrorMessage(error),
        }));
    }
};

export const updateCollegeRecruitmentDetails = (values) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await onboardingApi.updateCollegeRecruitmentDetails(mainApi, values);

        if (res.data.error) {
            dispatch(showErrorPopup({
                message: 'Error fetching onboarding status!',
                error: res.data.error,
            }));
        } else {
            return true;
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error fetching onboarding status',
            error: getApiErrorMessage(error),
        }));
    }
};

export const postUtrRangeSurvey = (values) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: ONBOARDING_POST_UTR_RANGE_SURVEY });
    try {
        const res = await onboardingApi.postUtrRangeSurveyV2(mainApi, values);

        if (res.data.errors && res.data.message) {
            dispatch({
                type: ONBOARDING_POST_UTR_RANGE_SURVEY_FAILURE,
                payload: res.data.message,
            });
            return false;
        }
        dispatch({
            type: ONBOARDING_POST_UTR_RANGE_SURVEY_SUCCESS,
            payload: res.data,
        });
        return true;
    } catch (error) {
        dispatch({
            type: ONBOARDING_POST_UTR_RANGE_SURVEY_FAILURE,
            payload: error.response?.data?.message || error.response?.data?.DisplayMessage,
        });
        return false;
    }
};

export const skipUtrRangeSurvey = () => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: ONBOARDING_SKIP_UTR_RANGE_SURVEY });
    try {
        const res = await onboardingApi.skipUtrRangeSurvey(mainApi);

        if (res.data.errors && res.data.message) {
            dispatch({
                type: ONBOARDING_SKIP_UTR_RANGE_SURVEY_FAILURE,
                payload: res.data.message,
            });
            return false;
        }
        dispatch({
            type: ONBOARDING_SKIP_UTR_RANGE_SURVEY_SUCCESS,
            payload: res,
        });
        return true;
    } catch (error) {
        dispatch({
            type: ONBOARDING_SKIP_UTR_RANGE_SURVEY_FAILURE,
            payload: error.response?.data?.message || error.response?.data?.DisplayMessage,
        });
        return false;
    }
};

export const postAustraliaOnboarding = (values) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await onboardingApi.postAustraliaOnboarding(mainApi, values);

        if (res.data.errors && res.data.message) {
            dispatch(showErrorPopup({
                message: 'Error fetching onboarding status!',
                error: res.data.error,
            }));
            return false;
        }
        dispatch({
            type: ONBOARDING_POST_AUSTRALIA_ONBOARDING_STATUS_SUCCESS,
            payload: values,
        });
        return true;
    } catch (error) {
        if (error.response.data.MessageStatusCode === TennisValidationStatusCode) {
            dispatch(showErrorPopup({
                message: TENNIS_VALIDATION_POPUP_DESCRIPTION,
                error: error.response.data.DisplayMessage,
            }));
        } else {
            dispatch(showErrorPopup({
                message: 'Error saving Tennis ID',
                error,
            }));
        }
    }
};

export const postTennisConnectId = (values) => async (dispatch, getState, { mainApi }) => {
    try {
        const res = await onboardingApi.postTennisConnectId(mainApi, values);

        if (res.data.errors && res.data.message) {
            dispatch(showErrorPopup({
                message: 'Error saving Tennis ID!',
                error: res.data.error,
            }));
            return false;
        }
        dispatch({
            type: ONBOARDING_POST_AUSTRALIA_TENNIS_ID_SUCCESS,
            payload: values,
        });
        return true;
    } catch (error) {
        if (error.response.data.MessageStatusCode === TennisValidationStatusCode) {
            dispatch(showErrorPopup({
                message: TENNIS_VALIDATION_POPUP_DESCRIPTION,
                error: error.response.data.DisplayMessage,
            }));
        } else {
            dispatch(showErrorPopup({
                message: 'Error saving Tennis ID',
                error,
            }));
        }
    }
};

export const showOnboardingRangePopup = (bool, type) => (dispatch) => {
    if (type === 'utrRange') {
        dispatch({
            type: ONBOARDING_SHOW_RANGE_POPUP,
            payload: bool,
        });
    } else {
        dispatch({
            type: ONBOARDING_SHOW_PBR_RANGE_POPUP,
            payload: bool,
        });
    }
};

export const getRatedPopupDismissed = () => (dispatch) => {
    dispatch({
        type: ONBOARDING_GET_RATED_POPUP_DISMISSED,
        payload: true,
    });
};

// NUO v2

export const setShowRating = (showRating, isFromStep) => (dispatch) => {
    dispatch({
        type: ONBOARDING_SET_SHOW_RATING,
        showRating,
        isFromStep,
    });
};

export const setShowPower = (bool) => (dispatch) => {
    dispatch({
        type: ONBOARDING_SET_SHOW_POWER,
        payload: bool,
    });
};

export const getOnboardingStatusV2 = () => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: ONBOARDING_GET_NUO_STATUS });
    try {
        const res = await onboardingApi.getOnboardingStatusV2(mainApi);
        if (res.data.error) {
            dispatch(showErrorPopup({
                message: 'Error fetching onboarding status',
                error: res.data.error,
            }));
        } else {
            if (res.data.onboardingCompleted) {
                await dispatch(fetchAuthenticatedUser());
                if (getState().auth?.user?.claimedPlayer) {
                    dispatch(setPlayerId(getState().auth?.user?.claimedPlayer?.playerId, false));
                }
            }
            dispatch({ type: ONBOARDING_GET_NUO_STATUS_SUCCESS, payload: res.data });
            // return res.data;
        }
    } catch (error) {
        dispatch(showErrorPopup({
            message: 'Error fetching onboarding status',
            error: getApiErrorMessage(error),
        }));
    }
};

export const postAdditionalInfoV2 = (data) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: ONBOARDING_POST_NUO_DATA });
    try {
        const res = await onboardingApi.postAdditionalInfoV2(mainApi, data);
        if (res.data.error) {
            dispatch(showErrorPopup({
                message: 'Error posting onboarding data',
                error: res.data.error,
            }));
        } else {
            dispatch(fetchAuthenticatedUser());
            dispatch(getOnboardingStatusV2());
        }
    } catch (error) {
        dispatch({ type: ONBOARDING_POST_NUO_DATA_FAILURE });
        dispatch(showErrorPopup({
            message: 'Error posting onboarding data',
            error: getApiErrorMessage(error),
        }));
    }
};

export const postMemberTypeV2 = (data) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: ONBOARDING_POST_NUO_DATA });
    try {
        const res = await onboardingApi.postMemberTypeV2(mainApi, data);
        if (res.data.error) {
            dispatch(showErrorPopup({
                message: 'Error posting onboarding data',
                error: res.data.error,
            }));
        } else {
            dispatch(getOnboardingStatusV2());
        }
    } catch (error) {
        dispatch({ type: ONBOARDING_POST_NUO_DATA_FAILURE });
        dispatch(showErrorPopup({
            message: 'Error posting onboarding data',
            error: getApiErrorMessage(error),
        }));
    }
};

export const postSportTypeV2 = (data) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: ONBOARDING_POST_NUO_DATA });
    try {
        const res = await onboardingApi.postSportTypeV2(mainApi, data);
        if (res.data.error) {
            dispatch(showErrorPopup({
                message: 'Error posting onboarding data',
                error: res.data.error,
            }));
        } else {
            dispatch(fetchAuthenticatedUser());
            dispatch(getOnboardingStatusV2());
        }
    } catch (error) {
        dispatch({ type: ONBOARDING_POST_NUO_DATA_FAILURE });
        dispatch(showErrorPopup({
            message: 'Error posting onboarding data',
            error: getApiErrorMessage(error),
        }));
    }
};
export const createPlayerV2 = (data) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: ONBOARDING_POST_NUO_DATA });
    try {
        const res = await onboardingApi.createPlayerV2(mainApi, data);
        if (res.data.error) {
            dispatch(showErrorPopup({
                message: 'Error creating player',
                error: res.data.error,
            }));
        } else {
            await dispatch(fetchAuthenticatedUser());
            if (getState().auth?.user?.claimedPlayer) {
                dispatch(setPlayerId(getState().auth?.user?.claimedPlayer?.playerId, false));
            }
            await dispatch(getOnboardingStatusV2());
        }
    } catch (error) {
        dispatch({ type: ONBOARDING_POST_NUO_DATA_FAILURE });
        dispatch(showErrorPopup({
            message: 'Error creating player',
            error: getApiErrorMessage(error),
        }));
    }
};
export const claimPlayerV2 = (data, isPlayerRated) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: ONBOARDING_POST_NUO_DATA });
    try {
        const res = await onboardingApi.claimPlayerV2(mainApi, data);
        if (res.data.error) {
            dispatch(showErrorPopup({
                message: 'Error claiming player profile',
                error: res.data.error,
            }));
        } else {
            if (isPlayerRated) {
                dispatch(setShowRating(true, NuoSteps.ClaimProfile));
            }
            await dispatch(fetchAuthenticatedUser());
            if (getState().auth?.user?.claimedPlayer) {
                dispatch(setPlayerId(getState().auth?.user?.claimedPlayer?.playerId, false));
            }
            await dispatch(getOnboardingStatusV2());
        }
    } catch (error) {
        dispatch({ type: ONBOARDING_POST_NUO_DATA_FAILURE });
        dispatch(showErrorPopup({
            message: 'Error claiming player profile',
            error: getApiErrorMessage(error),
        }));
    }
};
export const postColorballPlayerV2 = (data) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: ONBOARDING_POST_NUO_DATA });
    try {
        const res = await onboardingApi.colorballPlayerV2(mainApi, data);
        if (res.data.error) {
            dispatch(showErrorPopup({
                message: 'Error posting onboarding data',
                error: res.data.error,
            }));
        } else {
            dispatch(getOnboardingStatusV2());
        }
    } catch (error) {
        dispatch({ type: ONBOARDING_POST_NUO_DATA_FAILURE });
        dispatch(showErrorPopup({
            message: 'Error posting onboarding data',
            error: getApiErrorMessage(error),
        }));
    }
};
export const postColorballSurveyV2 = (data) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: ONBOARDING_POST_NUO_DATA });
    try {
        const res = await onboardingApi.colorballSurveyV2(mainApi, data);
        if (res.data.error) {
            dispatch(showErrorPopup({
                message: 'Error posting onboarding data',
                error: res.data.error,
            }));
        } else {
            dispatch(setShowRating(true, NuoSteps.CBRSurvey));
            await dispatch(fetchAuthenticatedUser());
            if (getState().auth?.user?.claimedPlayer) {
                dispatch(setPlayerId(getState().auth?.user?.claimedPlayer?.playerId, false));
            }
            dispatch(getOnboardingStatusV2());
        }
    } catch (error) {
        dispatch({ type: ONBOARDING_POST_NUO_DATA_FAILURE });
        dispatch(showErrorPopup({
            message: 'Error posting onboarding data',
            error: getApiErrorMessage(error),
        }));
    }
};

export const postTennisSurveyV2 = (data) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: ONBOARDING_POST_NUO_DATA });
    try {
        const res = await onboardingApi.tennisSurveyV2(mainApi, data);
        if (res.data.error) {
            dispatch(showErrorPopup({
                message: 'Error posting onboarding data',
                error: res.data.error,
            }));
        } else {
            dispatch(setShowRating(true, NuoSteps.UTRSurvey));
            await dispatch(fetchAuthenticatedUser());
            if (getState().auth?.user?.claimedPlayer) {
                dispatch(setPlayerId(getState().auth?.user?.claimedPlayer?.playerId, false));
            }
            dispatch(getOnboardingStatusV2());
        }
    } catch (error) {
        dispatch({ type: ONBOARDING_POST_NUO_DATA_FAILURE });
        dispatch(showErrorPopup({
            message: 'Error posting onboarding data',
            error: getApiErrorMessage(error),
        }));
    }
};

export const postPickleballSurveyV2 = (data) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: ONBOARDING_POST_NUO_DATA });
    try {
        const res = await onboardingApi.pickleballSurveyV2(mainApi, data);
        if (res.data.error) {
            dispatch(showErrorPopup({
                message: 'Error posting onboarding data',
                error: res.data.error,
            }));
        } else {
            dispatch(setShowRating(true, NuoSteps.PKBRSurvey));
            await dispatch(fetchAuthenticatedUser());
            if (getState().auth?.user?.claimedPlayer) {
                dispatch(setPlayerId(getState().auth?.user?.claimedPlayer?.playerId, false));
            }
            dispatch(getOnboardingStatusV2());
        }
    } catch (error) {
        dispatch({ type: ONBOARDING_POST_NUO_DATA_FAILURE });
        dispatch(showErrorPopup({
            message: 'Error posting onboarding data',
            error: getApiErrorMessage(error),
        }));
    }
};

export const postNCSAReg = (data) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: ONBOARDING_POST_NUO_DATA });
    const { auth } = getState();
    try {
        const res = await onboardingApi.postNCSAReg(mainApi, data);
        if (res.status !== 204) {
            gtag('event', {
                category: 'NCSA',
                context: 'NCSA Registration Unsuccessful Onboarding',
            });
            // segment track call - mapped to GA4
            if (window && window.analytics) {
                window.analytics.track('NCSA Registration Unsuccessful Onboarding', {
                    userId: auth?.user?.id,
                });
            }
            dispatch(showErrorPopup({
                message: 'Error posting onboarding data',
                error: res.data.error,
            }));
        } else {
            gtag('event', {
                category: 'NCSA',
                context: 'NCSA Registration Successful Onboarding',
            });
            // segment track call - mapped to GA4
            if (window && window.analytics) {
                window.analytics.track(`NCSA Registration Successful Onboarding - ${res.status}`, {
                    userId: auth?.user?.id,
                });
            }
            await dispatch(fetchAuthenticatedUser());
            dispatch(getOnboardingStatusV2());
        }
    } catch (error) {
        // segment track call - mapped to GA4
        if (window && window.analytics) {
            switch (error.response.status) {
                case 500:
                    gtag('event', {
                        category: 'NCSA',
                        context: 'NCSA Registration Unsuccessful Onboarding - Internal Server Error',
                    });
                    window.analytics.track('NCSA Registration Unsuccessful Onboarding - Internal Server Error', {
                        userId: auth?.user.id,
                    });
                    break;
                case 422:
                    gtag('event', {
                        category: 'NCSA',
                        context: 'NCSA Registration Unsuccessful Onboarding - API Validation Error',
                    });
                    window.analytics.track('NCSA Registration Unsuccessful Onboarding - API Validation Error', {
                        userId: auth?.user.id,
                    });
                    break;
                case 400:
                    gtag('event', {
                        category: 'NCSA',
                        context: 'NCSA Registration Unsuccessful Onboarding - Bad Request',
                    });
                    window.analytics.track('NCSA Registration Unsuccessful Onboarding - Bad Request', {
                        userId: auth?.user.id,
                    });
                    break;
                case 405:
                    gtag('event', {
                        category: 'NCSA',
                        context: 'NCSA Registration Unsuccessful Onboarding - Method Not Allowed',
                    });
                    window.analytics.track('NCSA Registration Unsuccessful Onboarding - Method Not Allowed', {
                        userId: auth?.user.id,
                    });
                    break;
                default:
                    gtag('event', {
                        category: 'NCSA',
                        context: 'NCSA Registration Unsuccessful Onboarding',
                    });
                    window.analytics.track('NCSA Registration Unsuccessful Onboarding', {
                        userId: auth?.user.id,
                    });
                    break;
            }
        }
        dispatch({ type: ONBOARDING_POST_NUO_DATA_FAILURE, payload: error.response.status });
    }
};

export const skipNCSAReg = (data) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: ONBOARDING_POST_NUO_DATA });
    try {
        const res = await onboardingApi.skipNCSAReg(mainApi, data);
        if (res.data.error) {
            dispatch(showErrorPopup({
                message: 'Error posting onboarding data',
                error: res.data.error,
            }));
        } else {
            dispatch(fetchAuthenticatedUser());
            dispatch(getOnboardingStatusV2());
        }
    } catch (error) {
        dispatch({ type: ONBOARDING_POST_NUO_DATA_FAILURE });
        dispatch(showErrorPopup({
            message: 'Error posting onboarding data',
            error: getApiErrorMessage(error),
        }));
    }
};

export const skipTennisSurveyV2 = (data) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: ONBOARDING_POST_NUO_DATA });
    try {
        const res = await onboardingApi.skipTennisSurveyV2(mainApi, data);
        if (res.data.error) {
            dispatch(showErrorPopup({
                message: 'Error posting onboarding data',
                error: res.data.error,
            }));
        } else {
            dispatch(fetchAuthenticatedUser());
            dispatch(getOnboardingStatusV2());
        }
    } catch (error) {
        dispatch({ type: ONBOARDING_POST_NUO_DATA_FAILURE });
        dispatch(showErrorPopup({
            message: 'Error posting onboarding data',
            error: getApiErrorMessage(error),
        }));
    }
};

export const skipPickleballSurveyV2 = (data) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: ONBOARDING_POST_NUO_DATA });
    try {
        const res = await onboardingApi.skipPickleballSurveyV2(mainApi, data);
        if (res.data.error) {
            dispatch(showErrorPopup({
                message: 'Error posting onboarding data',
                error: res.data.error,
            }));
        } else {
            await dispatch(fetchAuthenticatedUser());
            await dispatch(getOnboardingStatusV2());
        }
    } catch (error) {
        dispatch({ type: ONBOARDING_POST_NUO_DATA_FAILURE });
        dispatch(showErrorPopup({
            message: 'Error posting onboarding data',
            error: getApiErrorMessage(error),
        }));
    }
};

export const postTennisAustraliaV2 = (data) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: ONBOARDING_POST_NUO_DATA });
    try {
        const res = await onboardingApi.postTennisAustraliaV2(mainApi, data);
        if (res.data.error) {
            dispatch(showErrorPopup({
                message: 'Error posting onboarding data',
                error: res.data.error,
            }));
        } else {
            dispatch(fetchAuthenticatedUser());
            dispatch(getOnboardingStatusV2());
        }
    } catch (error) {
        dispatch({ type: ONBOARDING_POST_NUO_DATA_FAILURE });
        if (error.response.data.MessageStatusCode === TennisValidationStatusCode) {
            dispatch(showErrorPopup({
                message: TENNIS_VALIDATION_POPUP_DESCRIPTION,
                error,
            }));
        } else {
            dispatch(showErrorPopup({
                message: 'Error posting onboarding data',
                error: getApiErrorMessage(error),
            }));
        }
    }
};

export const skipTennisAustraliaV2 = (data) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: ONBOARDING_POST_NUO_DATA });
    try {
        const res = await onboardingApi.skipTennisAustraliaV2(mainApi, data);
        if (res.data.error) {
            dispatch(showErrorPopup({
                message: 'Error posting onboarding data',
                error: res.data.error,
            }));
        } else {
            dispatch(fetchAuthenticatedUser());
            dispatch(getOnboardingStatusV2());
        }
    } catch (error) {
        dispatch({ type: ONBOARDING_POST_NUO_DATA_FAILURE });
        dispatch(showErrorPopup({
            message: 'Error posting onboarding data',
            error: getApiErrorMessage(error),
        }));
    }
};

export const postPickleballRangeSurvey = (data) => async (dispatch, getState, { mainApi }) => {
    dispatch({ type: ONBOARDING_POST_PICKLEBALL_RANGE_SURVEY });
    dispatch({ type: 'SPLASH_SHOW' });
    try {
        const res = await onboardingApi.postPickleballRangeSurveyV2(mainApi, data);
        if (res.data.error) {
            dispatch({ type: ONBOARDING_POST_PICKLEBALL_RANGE_SURVEY_FAILURE });
            dispatch(showErrorPopup({
                message: 'Error posting onboarding data',
                error: res.data.error,
            }));
        } else {
            dispatch({
                type: ONBOARDING_POST_PICKLEBALL_RANGE_SURVEY_SUCCESS,
                payload: res.data,
            });
            dispatch(fetchAuthenticatedUser());
        }
        dispatch({ type: 'SPLASH_HIDE' });
    } catch (error) {
        dispatch({ type: ONBOARDING_POST_PICKLEBALL_RANGE_SURVEY_FAILURE });
        dispatch(showErrorPopup({
            message: 'Error posting pickleball survey',
            error: getApiErrorMessage(error),
        }));
        dispatch({ type: 'SPLASH_HIDE' });
    }
};
